<template>
  <div id="Announce">
    <b-navbar type="light" variant="light-success">
      <b-button v-b-toggle.sidemenu variant="outline-secondary" class="mr-2 d-lg-none"><f-icon icon="bars"></f-icon></b-button>
      <b-navbar-brand  class="mb-0" :to="{ path: '/ld' }" replace>
        <img :src="logoImg" class="d-inline-block align-top" alt="Logo" height="30px">
        {{ logoName }}
      </b-navbar-brand>
    </b-navbar>
    <b-sidebar id="sidemenu" title="Menu" body-class="px-2" shadow>
      <left-menu></left-menu>
    </b-sidebar>
    <b-container fluid class="bg-white shadow-sm">
      <b-modal id="modalAnnounce" size="xl" hide-footer>
        <template #modal-title>
          สร้างประกาศใหม่
        </template>
        <div class="d-block">
          <label for="form_announceDetail"><b>ข้อความประกาศ:</b> </label>
          <!-- <b-input-group>
            <template #prepend>

            </template>
            <b-form-input id="form_announceDetail" class="mb-2" v-model="form.announceDetail"></b-form-input>
          </b-input-group> -->
          <b-form-textarea rows="2"
            max-rows="4" id="form_announceDetail" class="mb-2" v-model="form.announceDetail"></b-form-textarea>

          <b-form-spinbutton id="demo-sb" min="1" max="5" placeholder="ลำดับประกาศ" v-model="form.number" class="mb-2"></b-form-spinbutton>

          <b-dropdown id="dropdownicon" text="เลือกไอคอนประกาศ" class="mb-2">
            <b-dropdown-item @click="form.icon = ''">( ไม่มี )</b-dropdown-item>
            <b-dropdown-item @click="form.icon = 'disease'"><f-icon icon="disease"></f-icon></b-dropdown-item>
            <b-dropdown-item @click="form.icon = 'first-aid'"><f-icon icon="first-aid"></f-icon></b-dropdown-item>
            <b-dropdown-item @click="form.icon = 'people-carry'"><f-icon icon="people-carry"></f-icon></b-dropdown-item>
            <b-dropdown-item @click="form.icon = 'truck-loading'"><f-icon icon="truck-loading"></f-icon></b-dropdown-item>
            <b-dropdown-item @click="form.icon = 'truck-moving'"><f-icon icon="truck-moving"></f-icon></b-dropdown-item>
            <b-dropdown-item @click="form.icon = 'plane-departure'"><f-icon icon="plane-departure"></f-icon></b-dropdown-item>
            <b-dropdown-item @click="form.icon = 'user-injured'"><f-icon icon="user-injured"></f-icon></b-dropdown-item>
          </b-dropdown>
          <b-dropdown :variant="form.color" id="dropdownicon" text="เลือกสีประกาศ" class="mb-2">
            <b-dropdown-item @click="form.color = 'warning'">สีเหลือง</b-dropdown-item>
            <b-dropdown-item @click="form.color = 'danger'">สีแดง</b-dropdown-item>
            <b-dropdown-item @click="form.color = 'secondary'">สีเทา</b-dropdown-item>
            <b-dropdown-item @click="form.color = 'success'">สีเขียว</b-dropdown-item>
            <b-dropdown-item @click="form.color = 'primary'">สีน้ำเงิน</b-dropdown-item>
            <b-dropdown-item @click="form.color = 'purple'">สีม่วง</b-dropdown-item>
            <b-dropdown-item @click="form.color = 'dark'">สีดำ</b-dropdown-item>
          </b-dropdown>
          <!-- <span class="text-left">test</span> -->
        </div>
        <b-card class="ex-card">
          <h5 class="text-secondary"><i>ตัวอย่างประกาศ</i></h5>
          <b-alert show :variant="form.color" :class="'border-1r border-' + form.color + ' mb-2'">
            <f-icon v-if="form.icon" :icon="form.icon"></f-icon>
            <span v-if="form.announceDetail" v-html="form.announceDetail.replaceAll('\n', '<br>')"></span><span v-if="!form.announceDetail">ข้อความประกาศ</span>
            <!-- เนื่องจากการแพร่ระบาดของ COVID-19 ทำให้ด่านมีการตรวจเข้มขึ้นและเกิดน้ำท่วมทำให้ขนส่งล่าช้าจากกำหนดการเดิม 2-3 วัน  -->
          </b-alert>
        </b-card>
        <div class="d-block text-right">
          <b-button v-if="form.announceId == 0" class="mt-3" @click="onInsert" :disabled="!form.announceDetail">เพิ่มประกาศ</b-button>
          <b-button v-if="form.announceId > 0" class="mt-3" variant="danger" @click="delConfirm" :disabled="!form.announceDetail">
            <!-- ลบประกาศ --><f-icon icon="trash"></f-icon>
          </b-button>
          <b-button v-if="form.announceId > 0" class="mt-3" @click="onUpdate" :disabled="!form.announceDetail">แก้ไขประกาศ</b-button>
        </div>
        <!-- <b-button class="mt-3" block @click="onUpdate">แก้ไขประกาศ</b-button> -->
      </b-modal>

      <b-row>
        <b-col cols="3" class="d-none d-lg-block pb-4 pt-2">
          
          <left-menu></left-menu>
        </b-col>
        <b-col lg="9" class="pt-4 pb-4 animate__animated animate__fadeIn">
          <b-row>
            <b-col sm="8">
              <h2>
                รายการประกาศหน้าเว็บ
                <br>
                <small class="text-muted">
                  [จำนวน <span :class="items.length === 5 ? 'text-danger font-weight-bold' : 'text-success'">{{items.length}}</span>/5 ประกาศ]
                </small>
              </h2>
            </b-col>
            <b-col sm="4" class="text-right">
              <!-- <b-button v-b-modal.modalAnnounce> -->
              <b-button @click="openDataAnnounce()">
                <f-icon icon="comment-alt"></f-icon>
                สร้างประกาศใหม่
              </b-button>
            </b-col>
          </b-row>

          <hr>
          
          <b-alert show :variant="item.color" :class="'border-1r alert-dismissible border-'+item.color" v-for="item in items" :key="item.id">
            <!-- {{item.announceDetail}} -->
            <f-icon v-if="item.icon" :icon="item.icon"></f-icon>
            <span v-html="item.announceDetail.replaceAll('\n', '<br>')"></span>
            <br>
            <b-badge pill variant="light">สร้างโดย {{ item.CREATE_USER }}</b-badge>
            <b-badge pill :variant="item.color">สร้างวันที่ {{ formatDate(item.CREATE_DATE) }}</b-badge>
            <!-- <b-badge pill variant="warning">ประกาศตั้งแต่ 00/00/0000 - 00/00/0000</b-badge> -->
            <!-- <b-badge pill variant="danger">ยกเลิกประกาศ 00/00/0000</b-badge> -->

            <b-button variant="link" class="close p-2" @click="openDataAnnounce(item)"><f-icon icon="edit" size="xs"></f-icon></b-button>
          </b-alert>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center mt-3 mb-2">
      {{ footerLC }}
    </b-container>
  </div>
</template>

<script>
import axios from "axios"; // api
import MenuBar from '@/components/Menubar' // เมนู
import AlertCard from '@/components/Alert' // แจ้งเดือน
export default {
  name: "Announces",
  components: {
    'left-menu': MenuBar,
    'alert-card': AlertCard
  },
  beforeCreate() {
    // เหตุการจะเกิดขึ้นก่อนที่ Component จะถูก render เข้าไปใน DOM
    // this.$liff.init({ liffId: this.$liff_register_profile }, function (data) {})
  },
  created() {
    // ทุกอย่างจะถูกเตรียมไว้ครบหมดแล้ว และสามารถเข้าถึงได้หมด
    // setInterval(this.getDataMap, 1000)
  },
  async mounted() {
    // จะเกิดขึ้นเมื่อ DOM ถูกสร้างเสร็จแล้ว เราสามารถ เข้าถึง Element ต่างๆใน DOM ได้ทั้งหมด
    // เช่นการ ดึงข้อมูลจาก input เป็นต้น
    this.getDataUser()
    await this.getDataAnnounce()
  },
  data() {
    return {
      items: [
        // {
        //   announceId: 1,
        //   icon: 'car-crash',
        //   color: 'warning',
        //   userName: 'admin1',
        //   CREATE_DATE: '2021-11-12',
        //   announceDetail: 'เนื่องจากการแพร่ระบาดของ COVID-19 ทำให้ด่านมีการตรวจเข้มขึ้นและเกิดน้ำท่วมทำให้ขนส่งล่าช้าจากกำหนดการเดิม 2-3 วัน'
        // }
      ],
      userData: {
        userName: '',
        firstName: '',
        lastName: '',
        telephoneNumber: '',
        userType: ''
      },
      form: {
        announceId: 0,
        icon: '',
        color: '',
        userName: '',
        number: '',
        CREATE_DATE: '',
        announceDetail: ''
      },
      dataReady: false,
    };
  },
  methods: {
    openDataAnnounce(dt) {
      if (dt) {
        // console.log(dt)
        // this.form = dt
        this.form.announceId = dt.announceId
        this.form.icon = dt.icon
        this.form.userName = this.userData.userName
        this.form.color = dt.color
        this.form.number = dt.number
        this.form.announceDetail = dt.announceDetail
        this.form.LAST_USER = this.userData.userName

        this.$bvModal.show('modalAnnounce')
      } else {
        if (this.items.length >= 5) {
          this.$swal("ไม่สามารถสร้างประกาศได้","เนื่องจากสามารถสร้างประกาศได้ไม่เกิน 5 ประกาศ หากต้องการสร้างประกาศใหม่ กรุณาลบประกาศเก่า","warning")
        } else {
          this.form.announceId = 0
          this.form.icon = ''
          this.form.userName = this.userData.userName
          this.form.color = 'warning'
          this.form.number = ''
          this.form.announceDetail = ''
          this.form.CREATE_USER = this.userData.userName

          this.$bvModal.show('modalAnnounce')
        }
      }
    },
    formatDate (strDate) {
      if (strDate) {
        var dtDate = strDate.split(' ')[0]
        var strDateShort = dtDate.split('-')[2] + '/' + dtDate.split('-')[1] + '/' + dtDate.split('-')[0]
        return strDateShort
      } else {
        return ''
      }
    },
    getDataAnnounce() {
      this.dataReady = false
      axios
        .get(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Announce/Announce_list?userName=" +
          this.userData.userName,
          {
            headers: this.getHeaderAPI('Announce_list', this.userData.userName)
          }
        )
        .then((response) => {
          let rs = response.data
          if (rs.status === true){
            // console.log('getDataAnnounce', rs)
            this.items = rs.data
            this.dataReady = true;
          } else {
            this.$swal("ผิดพลาด","ไม่สามารถดึงข้อมูลประกาศได้","error")
            this.dataReady = true;
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true;
          // this.errored = true
        });
    },
    getDataUser() {
      let lsUser = this.getDataStorageUser()
      if (lsUser) {
        this.userData = lsUser
      } else {
        this.$router.push('/Login')
      }      
    },
    onInsert (){
      console.log(this.form)
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Announce/Announce_add",
          this.form,
          {
            headers: this.getHeaderAPI('Announce_add', this.form.userName)
          }
        )
        .then(async (response) => {
          // console.log('onInsert', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","เพิ่มข้อมูลประกาศเรียบร้อย","success")
              .then((result) => {
                this.$bvModal.hide('modalAnnounce')
              })
            this.dataReady = true

            this.getDataAnnounce()
          } else {
            // console.log('onInsert Fail')
            this.$swal("ผิดพลาด","ไม่สามารถเพิ่มข้อมูลประกาศได้","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          // console.log(error.response)
          this.$swal("Error Insert","ไม่สามารถเพิ่มข้อมูลประกาศได้","error")
          this.dataReady = true
        })
    },
    onUpdate (){
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Announce/Announce_update",
          this.form,
          {
            headers: this.getHeaderAPI('Announce_update', this.form.userName)
          }
        )
        .then(async (response) => {
          // console.log('onUpdate', response)
          let rs = response.data
          if (rs.status === true) {
            this.$swal("สำเร็จ","แก้ไขข้อมูลประกาศเรียบร้อย","success")
              .then((result) => {
                this.$bvModal.hide('modalAnnounce')
              })
            this.dataReady = true

            this.getDataAnnounce()
          } else {
            // console.log('onUpdate Fail')
            this.$swal("ผิดพลาด","ไม่สามารถแก้ไขข้อมูลประกาศได้","error")
            this.dataReady = true
          }
        })
        .catch((error) => {
          // console.log(error.response)
          this.$swal("Error Update","ไม่สามารถแก้ไขข้อมูลประกาศได้","error")
          this.dataReady = true
        })
    },
    delConfirm () {
      this.$swal({
        title: 'ยืนยันการลบ',
        html: 'คุณต้องการลบ<br>' + this.form.announceDetail.replaceAll('\n', '<br>') + '<br>ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ยืนยัน'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delAnnounce()
        }
      })
    },
    delAnnounce () {
      this.dataReady = false
      axios
        .post(
          // eslint-disable-next-line quotes
          "https://licm-cargo.com/api/Announce/Announce_delete",
          this.form,
          {
            headers: this.getHeaderAPI('Announce_delete', this.form.userName)
          }
        )
        .then(async (response) => {
          // console.log('delAnnounce resp: ', response)
          let rs = response.data
          if (rs.status === true) {
            // this.$swal("สำเร็จ","ลบประกาศเรียบร้อย","success")
            this.$swal("สำเร็จ","ลบประกาศเรียบร้อย","success")
              .then((result) => {
                this.$bvModal.hide('modalAnnounce')
              })
            this.dataReady = true
            this.getDataAnnounce()
          } else {
            // console.log('registerUser Fail')
            this.$swal("ผิดพลาด","ไม่สามารถลบประกาศได้","error")
            this.dataReady = true
          }
          this.dataReady = true
        })
        .catch((error) => {
          // console.log(error.response)
          this.$swal("ผิดพลาด","ไม่สามารถลบประกาศได้","error")
          this.dataReady = true
        })
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#form-profile {
  text-align: left;
}

.py-75{
  padding-top: .75rem !important;
  padding-bottom: .75rem !important;
}

.ex-card{
  border-style: dotted;
  border-width: 2px;
}

.ex-card > .card-body {
  padding: .75rem;
}

.dropdown-menu {
  min-width: 5rem !important;
  /* text-align: center; */
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Announce.vue